/* eslint-disable */
function _interopDefault(ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex.default : ex }

const _mergeJSXProps = _interopDefault(require('babel-helper-vue-jsx-merge-props'))

const CarIcon = {
  name: 'CarIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x'
      },
    },
  },
  functional: true,
  render: function render(h, ctx) {
    const size = ctx.props.size.slice(-1) === 'x' ? `${ctx.props.size.slice(0, ctx.props.size.length - 1)}em` : `${parseInt(ctx.props.size)}px`
    const attrs = ctx.data.attrs || {}
    attrs.width = attrs.width || size
    attrs.height = attrs.height || size
    ctx.data.attrs = attrs
    return h('svg', _mergeJSXProps([{
      attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        width: '34',
        height: '34',
        viewBox: '0 0 34 34',
        fill: 'none',
        stroke: 'currentColor',
        'stroke-width': '2',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
      },
      class: 'feather feather-car',
    }, ctx.data]), [

      h('path', {
        attrs: {
          fill: 'currentColor',
          d: 'M15 17h3v2h-3z',
        },
      }),
      h('path', {
        attrs: {
          fill: 'currentColor',
          d: 'M26.45 14.17A22.1 22.1 0 0 0 19.38 7a9.64 9.64 0 0 0-9-.7a8.6 8.6 0 0 0-4.82 6.4c-.08.47-.14.92-.2 1.36A4 4 0 0 0 2 18v6.13a2 2 0 0 0 2 2V18a2 2 0 0 1 2-2h18.73A7.28 7.28 0 0 1 32 23.27V24h-2a4.53 4.53 0 1 0 .33 2H32a2 2 0 0 0 2-2v-.73a9.28 9.28 0 0 0-7.55-9.1ZM11 14H6.93c0-.31.09-.63.15-1A6.52 6.52 0 0 1 11 8Zm2 0V7.58a8.17 8.17 0 0 1 5.36 1.16A19 19 0 0 1 23.9 14Zm12.8 14.38a2.5 2.5 0 1 1 2.5-2.5a2.5 2.5 0 0 1-2.5 2.5Z',
        },
      }),
      h('path', {
        attrs: {
          fill: 'currentColor',
          d: 'M14.17 24a4.53 4.53 0 1 0 .33 2h5.3v-.25A6 6 0 0 1 20 24ZM10 28.38a2.5 2.5 0 1 1 2.5-2.5a2.5 2.5 0 0 1-2.5 2.5Z',
        },
      }),

    ])
  },
}

const CarIcon2 = {
  name: 'CarIcon2',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x'
      },
    },
  },
  functional: true,
  render: function render(h, ctx) {
    const size = ctx.props.size.slice(-1) === 'x' ? `${ctx.props.size.slice(0, ctx.props.size.length - 1)}em` : `${parseInt(ctx.props.size)}px`
    const attrs = ctx.data.attrs || {}
    attrs.width = attrs.width || size
    attrs.height = attrs.height || size
    ctx.data.attrs = attrs
    return h('svg', _mergeJSXProps([{
      attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        width: '24',
        height: '24',
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        'stroke-width': '0.8',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
      },
      class: 'feather feather-car2',
    }, ctx.data]), [

      h('path', {
        attrs: {
          fill: 'currentColor',
          d: 'm20.772 10.156l-1.368-4.105A2.995 2.995 0 0 0 16.559 4H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.105A2.003 2.003 0 0 0 2 12v5c0 .753.423 1.402 1.039 1.743c-.013.066-.039.126-.039.195V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h12v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.062c0-.069-.026-.13-.039-.195A1.993 1.993 0 0 0 22 17v-5c0-.829-.508-1.541-1.228-1.844zM4 17v-5h16l.002 5H4zM7.441 6h9.117c.431 0 .813.274.949.684L18.613 10H5.387l1.105-3.316A1 1 0 0 1 7.441 6z',
        },
      }),

      h('circle', {
        attrs: {
          fill: 'currentColor',
          cx: '6.5',
          cy: '14.5',
          r: '1.5',
        },
      }),
      h('circle', {
        attrs: {
          fill: 'currentColor',
          cx: '17.5',
          cy: '14.5',
          r: '1.5',
        },
      }),

    ])
  },
}

exports.CarIcon = CarIcon;
exports.CarIcon2 = CarIcon2;
